<template>
  <el-dialog
    :visible.sync="visible"
    title="采购合同详情"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    width="70%"
  >
    <el-form :model="dataForm" ref="dataForm" label-width="120px">
      <el-card v-if="dataForm && dataForm.id">
        <div slot="header" class="card-header">
          <div>合同信息</div>
        </div>
        <el-row :gutter="16">
          <el-col :span="6">
            <el-form-item label="外销合同编号：">
              {{ dataForm.orderAgreementCode }}
            </el-form-item>
          </el-col>
          <el-col :span="6" v-if="dataForm.factoryId">
            <el-form-item label="接收工厂：">
              {{ dataForm.factoryName }}
            </el-form-item>
          </el-col>
          <el-col :span="6" v-if="dataForm.storageId">
            <el-form-item label="接收仓库：">
              {{ dataForm.storageName }}
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="合同总价：" >
              {{dataForm.totalAmount  }}
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="交付日期：" >
              {{ dataForm.deadline }}
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="操作人：" >
              {{ dataForm.creatorName }}
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="操作时间：" >
              {{ dataForm.createDate }}
            </el-form-item>
          </el-col>
        </el-row>
        <el-form-item label="备注：" prop="remark">
          {{ dataForm.remark||'暂无' }}
        </el-form-item>
      </el-card>

      <el-card>
        <div slot="header" class="card-header">
          <div>合同明细</div>
        </div>
        <el-table
          v-if="
            dataForm && dataForm.detailList && dataForm.detailList.length > 0
          "
          :data="dataForm.detailList"
          border
          style="width: 100%"
        >
          <el-table-column
            type="index"
            width="50"
            label="行号"
            header-align="center"
            align="center"
          ></el-table-column>
          <el-table-column label="产品名称" prop="name" align="center">
          </el-table-column>

          <el-table-column
            label="颜色"
            prop="color"
            header-align="center"
            align="center"
          >
          </el-table-column>
          <el-table-column
            label="尺寸"
            prop="size"
            header-align="center"
            align="center"
          >
          </el-table-column>
          <el-table-column
            label="规格"
            prop="attr1"
            header-align="center"
            align="center"
          >
          </el-table-column>
          <el-table-column
            label="其他"
            prop="attr2"
            header-align="center"
            align="center"
          >
          </el-table-column>
          <el-table-column
            label="数量"
            header-align="center"
            align="center"
            width="120"
            prop="count"
          >
          </el-table-column>
          <el-table-column
            label="采购单价"
            header-align="center"
            align="center"
            width="120"
          >
            <template slot-scope="scope">
              {{ scope.row.amount}}
            </template>
          </el-table-column>
          <el-table-column
            label="小计"
            header-align="center"
            align="center"
            width="120"
          >
            <template slot-scope="scope">
              {{ scope.row.totalAmount }}
            </template>
          </el-table-column>

          <el-table-column label="备注" prop="remark" header-align="center" align="center">
          </el-table-column>
        </el-table>
      </el-card>
    </el-form>
    <template slot="footer">
      <el-button @click="cancel">关闭</el-button>
    </template>
  </el-dialog>
</template>

<script>
export default {
  data() {
    return {
      id: "",
      visible: false,
      dataForm: {
        agreementCode: "",
        agreementId: "",
        code: "",
        createDate: "",
        creator: "",
        creatorName: "",
        deadline: "",
        detailList: [],
        factoryId: "",
        factoryName: "",
        id: "",
        productCount: "",
        remark: "",
        status: "",
        totalAmount: "",
        totalCount: "",
      },
    };
  },
  methods: {
    init() {
      this.getInfo();
      this.visible = true;
    },
    // 获取信息
    getInfo() {
      this.$http
        .get(`/trade/purchase/agreement/${this.id}`)
        .then(({ data: res }) => {
          if (res.code !== 0) {
            return this.$message.error(res.msg);
          }
          res.data.detailList.forEach(item=>{
            item.totalAmount=item.count*item.amount
          })
          this.dataForm = res.data;
        })
        .catch(() => {});
    },
    cancel() {
      this.visible = false;
    },
  },
};
</script>
